<template>
  <v-container class="d-flex justify-center flex-wrap">
    <div class="form-container narrow">
      <span class="form-header">Export</span>
      {{ state.selectedApi }}Form
      <v-form>
        <v-select
          required
          density="compact"
          label="Select WMS"
          variant="outlined"
          :items="apiOptions"
          v-model="state.selectedApi"></v-select>
        <component :is="`${state.selectedApi}Form`"></component>
      </v-form>
    </div>

    <v-icon class="align-self-center mx-8" size="x-large">mdi-transfer-right</v-icon>

    <div class="form-container narrow">
      <span class="form-header">Import</span>
      <nova-import-form></nova-import-form>
    </div>
  </v-container>
</template>

<script lang="ts">
import { computed, reactive } from 'vue';
import { APIs } from '@/enums/APIs';
import AppointmentPlusForm from '@/components/forms/AppointmentPlusForm.vue';
import NovaForm from '@/components/forms/NovaForm.vue';
import NovaImportForm from '@/components/forms/NovaImportForm.vue';

export default {
  name: 'DataTransferView',
  components: {
    NovaImportForm,
    AppointmentPlusForm,
    NovaForm
  },
  setup() {
    const state = reactive({
      selectedApi: APIs.AP
    });
    const apiOptions = computed(() => Object.values(APIs));

    return {
      apiOptions,
      state,
      APIs
    };
  }
};
</script>

<style lang="scss">
.narrow {
  width: 500px;
}

.form-container {
  position: relative;
  margin-top: 2rem;
  padding: 2rem;
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;

  .form-header {
    text-transform: uppercase;
    position: absolute;
    top: 0;
    display: block;
    background: white;
    transform: translate(-50%, -50%);
    left: 50%;
    font-weight: bold;
    padding: 0 1rem;
  }
}
</style>
